<div>
  <app-report-cycles-filter (search)="searchReportCycles($event)"></app-report-cycles-filter>
  <mat-divider></mat-divider>
  <app-report-cycles-table *ngIf="reportCyclesPage"
  [page]="reportCyclesPage.number"
  [pageSize]="reportCyclesPage.size"
  [totalElements]="reportCyclesPage.totalElements"
  [reportCycles]="reportCyclesPage.content"
  (loadReportCycles)="loadReportCycles($event)"
  (openReportCycle)="openReportCycle($event)"
  (printReportCycle)="printReportCycle($event)">
  </app-report-cycles-table>
</div>
